/**
 * useAuth hook — reads from UserContext
 * Provides convenient access to auth state and actions
 */

import { useUserContext } from '@/contexts/UserContext';

export function useAuth() {
  const { 
    user, 
    isAuthenticated, 
    isLoading, 
    login, 
    logout, 
    refreshProfile, 
    updateProfile,
    resendConfirmationEmail 
  } = useUserContext();

  return {
    user,
    isAuthenticated,
    isLoading,
    login,
    logout,
    refreshProfile,
    updateProfile,
    resendConfirmationEmail,
    // Computed helpers
    surveyCompleted: user?.surveyCompleted ?? false,
    emailConfirmed: user?.emailConfirmed ?? false,
  };
}

export default useAuth;
